import React from 'react';
import { faqs } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Accordion } from './Accordion';
export function FaqSection() {
  return <section className="bg-cream px-5 py-10 sm:px-8 lg:py-14" data-id="element-26" data-mp="1phxh1e1j5m0v">
      <div className="mx-auto w-full max-w-[840px]" data-id="element-27" data-mp="1bm3gbiawu2yu">
        <SectionTitle className="uppercase" data-id="element-28" data-mp="1gjbz9l3vub15">
          Preguntas frecuentes
        </SectionTitle>

        <div className="mt-6 space-y-3" data-id="element-29" data-mp="249g601cdaqwd">
          {faqs.map((faq, i) => <Accordion key={faq.question} id={`faq-${i + 1}`} className="bg-white" openClassName="bg-white" header={<span className="flex items-start gap-4" data-id="element-31" data-mp="28cvwefxufv0m">
                  <span className="font-display text-[15px] font-semibold text-coral" data-id="element-32" data-mp="1uibr11moz61j">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span className="font-sans text-[16px] font-bold leading-snug text-ink sm:text-[17px]" data-id="element-33" data-mp="2n8bwp2p0on5g">
                    {faq.question}
                  </span>
                </span>} data-id="element-30" data-mp="24baqjejq8gzx" data-mpi={i}>
              <p className="pl-[31px] font-sans text-[16px] leading-relaxed text-ink-soft" data-id="element-34" data-mp="14va9hr568kz7">
                {faq.answer}
              </p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}